import { render, staticRenderFns } from "./SendSafetyConfirmToOtherUserComplete.vue?vue&type=template&id=cfb0e536&lang=pug"
import script from "./SendSafetyConfirmToOtherUserComplete.vue?vue&type=script&lang=ts"
export * from "./SendSafetyConfirmToOtherUserComplete.vue?vue&type=script&lang=ts"
import style0 from "./SendSafetyConfirmToOtherUserComplete.vue?vue&type=style&index=0&id=cfb0e536&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports